import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Hard-deletes all notifications owned by the current user.
 *
 * @param instance - Ky HTTP instance.
 * @returns OperationResult (no payload).
 */
export const deleteAllNotifications = async (instance: KyInstance): Promise<OperationResult> => {
  try {
    return await instance.delete<OperationResult>(Uri.notifications.base).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
